import { z } from "zod";
import { AbstractDictionnarySchema } from "./abstract/abstractDictionary.entities";

export enum DictionaryPatientSchemaEnum {
	DictionaryPatient = "DictionaryPatient"
};

export const DictionaryPatientSchema = AbstractDictionnarySchema.merge(z.object({
	"@id": z.string(),
	id: z.number(),
	numero: z.string(),
	last_name: z.string(),
	first_name: z.string(),
	birth_date: z.string(),
	email: z.string(),
	phone: z.string(),
	phone_mobile: z.string(),
	id_secu: z.string(),
	aw_id: z.string(),
	doublon_aw_ids: z.string(),
	new_import_id: z.string(),
})).describe(DictionaryPatientSchemaEnum.DictionaryPatient);

export type DictionaryPatient = z.infer<typeof DictionaryPatientSchema>;
